import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getObjectKeys',
})
export class GetObjectKeysPipe implements PipeTransform {
  transform(value: any): string[] {
    if (value && typeof value === 'object') {
      return Object.keys(value);
    }
    return [];
  }
}
